import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Positions/Add";
import { TableData } from "@/App/Positions/Table";
import { getPositionsData } from "@/Api/positions";
import { PositionProps } from "@/types/position";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { PageHeader } from "@/components/PageHeader";
import { Briefcase } from "lucide-react";
import { UnityFilter, useUnityFilter } from "@/components/UnityFilter";

export type TableDataProps = PositionProps;

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  const unityFilter = useUnityFilter();

  useEffect(() => {
    if (!unityFilter.ready) return;
    (async () => {
      setState("loading");
      const { data } = await getPositionsData(1, unityFilter.param, unityFilter.nameParam);
      setListData(data?.response);
      setState("production");
    })();
  }, [unityFilter.ready, unityFilter.param, unityFilter.nameParam]);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getPositionsData(listData?.current_page + 1, unityFilter.param, unityFilter.nameParam);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getPositionsData(listData?.current_page - 1, unityFilter.param, unityFilter.nameParam);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getPositionsData(listData?.last_page, unityFilter.param, unityFilter.nameParam);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-positions-list")}>
        <PageHeader
          icon={Briefcase}
          title="Cargos"
          description="Gerencie os cargos e o setor de cada um"
        >
          <If condition={hasPermission("create-position")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <UnityFilter filter={unityFilter} namePlaceholder="Buscar por nome" />
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
